import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 4h-3v16h3","key":"svg-0"}],["path",{"d":"M16 4h3v16h-3","key":"svg-1"}]]

const IconBrackets = createReactComponent('outline', 'brackets', 'Brackets', __iconNode);

export default IconBrackets;